//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'


const selectore = (state) => {
    return state.differentiationLesson
};
export const useDifferentiationLesson = () => {
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}
